import { render, staticRenderFns } from "./CredenciamentoFornecedorPropostaItemAnexo.vue?vue&type=template&id=88ac4924"
import script from "./CredenciamentoFornecedorPropostaItemAnexo.vue?vue&type=script&lang=js"
export * from "./CredenciamentoFornecedorPropostaItemAnexo.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoFornecedorPropostaItemAnexo.vue?vue&type=style&index=0&id=88ac4924&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports